import { Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { sortString } from '@nephro/commons/helpers/utils';
import { useTranslation } from 'react-i18next';
import { EyeOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import useFormatDate from 'hook/useFormatDate';
import { useHistory, useLocation } from 'react-router-dom';

const PatientsMassiveProcessingColumns = (translate, history) => {
  const location = useLocation();

  return [
    {
      title: translate('patientMg.name'),
      dataIndex: 'name',
      sorter: sortString('name')
    },
    {
      title: translate('patientMg.start_date'),
      dataIndex: 'start_date',
      sorter: sortString('start_date')
    },
    {
      title: translate('patientMg.patient_status'),
      dataIndex: 'patient_status',
      sorter: sortString('patient_status')
    },
    {
      title: translate('patientMg.end_date'),
      dataIndex: 'end_date',
      sorter: sortString('end_date')
    },
    {
      title: translate('patientMg.total_patients'),
      dataIndex: 'total_patients',
      sorter: sortString('total_patients')
    },
    {
      title: translate('patientMg.patient_success'),
      dataIndex: 'patient_success',
      sorter: sortString('patient_success')
    },
    {
      title: translate('patientMg.patient_failed'),
      dataIndex: 'patient_failed',
      sorter: sortString('patient_failed')
    },
    {
      title: translate('patientMg.see_details'),
      width: 150,
      dataIndex: 'actions',
      fixed: 'right',
      // eslint-disable-next-line react/display-name
      render: (_, item) => {
        const { id } = item;

        const onNavigateTo = () => {
          const baseUrl = location.pathname;
          const lastCharURL = baseUrl[baseUrl.length - 1];
          const goTo = lastCharURL === '/' ? `${id}` : `/${id}`;

          history.push(`${location.pathname}${goTo}`);
        };
        return (
          <div>
            <div className="w-full min-w-min max-w-2 space-x-5 items-center hidden md:flex">
              <EyeOutlined onClick={() => onNavigateTo()} />
            </div>
          </div>
        );
      }
    }
  ];
};

function PatientsMassiveProcessingContainer({ patientActions }) {
  const history = useHistory();
  const { listPatientMProcessing } = patientActions;
  const [rows, setRows] = useState([]);

  useEffect(() => {
    listPatientMProcessing(null, (res) =>
      setRows(
        res.content.map((user) => {
          return {
            id: user.id_patient_mprocessing,
            name: user.user_process,
            start_date: useFormatDate(user.created_at, true),
            patient_status: user.patient_mprocess_status.description,
            end_date: useFormatDate(user.finished, true),
            total_patients: user.total_patients,
            patient_success: user.success,
            patient_failed: user.fail
          };
        })
      )
    );
  }, []);

  const isVirtualPagination = true;
  const { t: translate } = useTranslation();
  const columns = PatientsMassiveProcessingColumns(translate, history);
  const onChangePagination = () => {};

  const onChange = () => {};

  return (
    <div>
      <div className="h-full mt-20">
        <div className="flex flex-wrap">
          <div className="w-full overflow-x-scroll">
            <Table
              bordered={false}
              columns={columns}
              dataSource={rows}
              size="small"
              scroll={{ x: true }}
              rowKey={(record, i) => `${record.documento}-${i}`}
              onChange={isVirtualPagination ? onChangePagination : onChange}
              pagination={
                isVirtualPagination
                  ? {
                      position: ['bottomCenter'],
                      showSizeChanger: false,
                      hideOnSinglePage: true
                    }
                  : false
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}

PatientsMassiveProcessingContainer.propTypes = {
  actions: PropTypes.shape({
    setLoading: PropTypes.func.isRequired
  }),
  authActions: PropTypes.shape({
    recoverPassword: PropTypes.func.isRequired
  }).isRequired,
  patientActions: PropTypes.shape({
    listPatientMProcessing: PropTypes.func.isRequired
  }).isRequired,
  dashboardStaffActions: PropTypes.shape({
    getAdmonCodesByEntity: PropTypes.func.isRequired
  }).isRequired,
  clinicId: PropTypes.number,
  lastVersiaUpdate: PropTypes.string,
  user: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]).isRequired
};

export default PatientsMassiveProcessingContainer;
